/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Upsell_History_BodyInputs */



/**
* | output |
* | --- |
* | "See charts further back, and compare this month with the same month last year." |
*
* @param {Upsell_History_BodyInputs} inputs
* @param {{ locale?: "en" | "ru" }} options
* @returns {LocalizedString}
*/
export const upsell_history_body = /** @type {((inputs?: Upsell_History_BodyInputs, options?: { locale?: "en" | "ru" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Upsell_History_BodyInputs, { locale?: "en" | "ru" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ru") return /** @type {LocalizedString} */ ("Смотрите графики глубже в прошлое и сравнивайте месяц с тем же месяцем прошлого года.")
	return /** @type {LocalizedString} */ ("See charts further back, and compare this month with the same month last year.")
});